export default __webpack_public_path__ + "static/media/a019-1.e676846f.svg";